import React from 'react';

import { Column } from 'app/shopify/components/layout';

import { TextField } from './TextField';

export function TextFieldShowcase() {
  return (
    <Column gap="spacing.general.x4" padding="spacing.general.x4">
      <TextField label="Label" placeholder="Placeholder" size="default" helperText="Helper text" />
      <TextField label="Label" value="Input" size="small" helperText="Helper text" />
      <TextField label="Label" value="Input" size="default" state="active" showClearButton />
      <TextField label="Label" value="Input" size="small" state="focus" showClearButton />
      <TextField label="Label" value="Input" size="default" state="readOnly" showInfoIcon />
      <TextField label="Label" placeholder="Placeholder" size="default" state="disabled" helperText="Helper text" />
      <TextField
        label="Label"
        value="Input"
        size="default"
        validation="error"
        showClearButton
        errorMessage="Error message"
      />
    </Column>
  );
}
